var map = {
	"./1.gif": "jKUr",
	"./2.gif": "NusM",
	"./3.gif": "05ir",
	"./4.gif": "Zh81",
	"./5.gif": "Yp39",
	"./6.gif": "4rbc",
	"./7.gif": "VJRN",
	"./8.gif": "KuPk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tD0T";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile ^\.\/.*\.gif$
// module id = tD0T
// module chunks = 1